// extracted by mini-css-extract-plugin
module.exports = {"Search":"Search_Search__2-oP4","SearchHeader":"Search_SearchHeader__2DUKn","SearchBox":"Search_SearchBox__1cqMx"};